export default "__VITE_ASSET__tVlHDzRy__"